import React from 'react';
import {Image, Text, View} from "@react-pdf/renderer";
import {withTranslation} from "react-i18next";

const Images = ({t,data}) => {
  const {images = []} = data;

  return (
    <View>
      <Text style={{marginBottom: '20px', fontFamily: 'pdfFont',}}>{t("Images")}</Text>


      <View style={{display: 'flex', flexFlow: 'row', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center'}}>
        {
          images.map(({thumbnailLink}) =>
            <View key={thumbnailLink} style={{width: '150px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginRight: '10px', marginBottom: '10px'}}>
              <Image style={{width: '150px', height: '150px', marginRight: '10px', objectFit: 'cover'}} src={thumbnailLink}/>
            </View>
          )
        }
      </View>

      <Text break />
    </View>
  );
};

export default withTranslation()(Images);